import { createSlice } from '@reduxjs/toolkit';

import store from './store';

import endPoints from '../api/endpoint';
import { getApiCall, postApiCall, putApiCall } from '../api/methods';
import { notify } from '../Utils/toastify';

import { SetState } from '../types';
import { setCrewDocCount, setOrderSetCount } from './ProductionSlice';

const initialState: SetState = {
  setDetails: {},
  departmentList: {},
  setList: {},
  setSpendingGraph: {},
  setLocations: {},
  graphLoader: true,
  loading: false,
  episodeList: [],
  setDetailbanner: {},
  setFormData: {},
  contacts: [],
};

const setSlice = createSlice({
  name: 'set',
  initialState,
  reducers: {
    updateSetDetails: (state: any, action: any) => {
      const { payload }: any = action;
      state.setDetails = payload;
    },
    updateSetDepartmentlist: (state: any, action: any) => {
      const { payload }: any = action;
      state.departmentList = payload;
    },
    updateSetList: (state: any, action: any) => {
      const { payload }: any = action;
      state.setList = payload;
    },
    setSetSpendingGraph: (state, action) => {
      const { payload }: any = action;
      state.setSpendingGraph = payload;
    },
    setSetsLocationList: (state, action) => {
      const { payload }: any = action;
      state.setLocations = payload;
    },
    setRemoveLocatoins: (state, action) => {
      const { payload }: any = action;
      state.setLocations = payload;
    },
    setLoading: (state, action) => {
      const { payload }: any = action;
      state.loading = payload;
    },
    setEpisodeList: (state, action) => {
      const { payload }: any = action;
      state.episodeList = payload;
    },
    setSetDetailbanner: (state, action) => {
      const { payload }: any = action;
      state.setDetailbanner = payload;
    },
    setSetFormDetails: (state, action) => {
      const { payload }: any = action;
      state.setFormData = payload;
    },
    setSetContactsList: (state, action) => {
      const { payload }: any = action;
      state.contacts = payload;
    },
  },
});

export const {
  updateSetDetails,
  updateSetDepartmentlist,
  updateSetList,
  setSetSpendingGraph,
  setSetsLocationList,
  setRemoveLocatoins,
  setLoading,
  setEpisodeList,
  setSetDetailbanner,
  setSetFormDetails,
  setSetContactsList,
} = setSlice.actions;

export default setSlice.reducer;

export const getSetDetails = (setId: any, cb?: any) => {
  const { dispatch } = store;

  dispatch(setLoading(true)); // Show loader before the API call

  getApiCall(
    `${endPoints.setDetailbanner}${setId}`,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        dispatch(updateSetDetails(data.data));
        if (cb) cb(data.data); // Call the callback function if provided
      }
      dispatch(setLoading(false)); // Hide loader after successful response
    },
    (e: any) => {
      // Handle error if necessary (you can log it or display a toast, etc.)
      console.error('Error fetching production details:', e);
      dispatch(setLoading(false)); // Hide loader after error
    },
  );
};

export const getDepartmentListOfSet = (setId: any, cb?: any) => {
  const { dispatch } = store;
  // dispatch(setLoading(true))
  const apiendpoint = `${endPoints.set.departmentList}&entityId=${setId}`;
  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        dispatch(updateSetDepartmentlist(data.data));
        cb(data.data);
      }
      // dispatch(setLoading(false))
    },

    (e: any) => {
      console.log(e);
    },
  );
};

export const getSetList = (cb?: any) => {
  const { dispatch } = store;
  // dispatch(setLoading(true))
  const apiendpoint = endPoints.set.setList;
  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;
      if (data) {
        dispatch(updateSetList(data.data));
        cb(data.data);
      }
      // dispatch(setLoading(false))
    },

    (e: any) => {
      console.log(e);
    },
  );
};

export const getSetSpendingGraph = (
  type: string,
  id: string,
  range: string,
  productionId?: string,
  cb?: any,
) => {
  const { dispatch } = store;
  // Build the API endpoint with the query and studioId
  let apiendpoint = endPoints.production.spendingGraph(type, id, range);

  if (productionId) {
    apiendpoint = `${apiendpoint}&productionId=${productionId}`;
  }

  // Make the API call
  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        // Check the status value and dispatch the appropriate action
        // console.log('data', data)
        dispatch(setSetSpendingGraph(data?.data));

        cb(data.data);
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        // notify(e?.data.message, 'error')
      } else {
        // notify(null, 'error')
      }
    },
  );
};

export const getSetLocationList = (setId: string, urlParam?: any, cb?: any) => {
  const { dispatch } = store;
  // dispatch(setLoading(true))

  const apiendpoint = `${urlParam}?setId=${setId}`;

  // Make the API call
  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        // Check the status value and dispatch the appropriate action
        // console.log('data==========>>>>>>>>>>>', data)
        dispatch(setSetsLocationList(data?.data));

        cb(data.data);
      }

      // Stop loading indicator
      // dispatch(setLoading(false))
    },
    (e: any) => {
      // Handle error, stop loading
      // dispatch(setLoading(false))
    },
  );
};

export const removeLocationList = () => (dispatch: any) => {
  dispatch(setRemoveLocatoins({}));
};

export const getEpisodeList = (productionId: string) => {
  const { dispatch } = store;
  const apiendpoint = endPoints.set.episodeListByProduction;

  // Make the API call
  getApiCall(
    `${apiendpoint}?productionId=${productionId}`,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        dispatch(setEpisodeList(data?.data));
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        //    notify(e?.data.message, 'error')
      } else {
        //   notify(null, 'error')
      }
    },
  );
};

export const createSet = (
  values: any,
  type?: string,
  cb?: (data: any) => void,
  onError?: () => void,
) => {
  postApiCall(
    endPoints.set.createSet,
    values,
    (s: any) => {
      const {
        data: { statusCode, message, data },
      } = s;
      if (statusCode && statusCode === 200) {
        notify(
          `${type == 'Event' ? 'Activity' : 'Set'} created successfully`,
          'success',
        );
        if (cb) cb(data);
      }
    },
    (e: any) => {
      if (e?.data?.message === 'Set already exists.') {
        notify(
          `The ${
            type === 'Event' ? 'Activity' : 'Set'
          } is already associated to this ${type?.toLowerCase()}`,
          'error',
        );
      } else {
        notify(e.data.message, 'error');
      }
      if (onError) onError(); // ✅ call this too
    },
  );
};

export const updateSet = (
  setId: string,
  values: any,
  type: string,
  cb?: () => void,
  onError?: () => void, // 👈 add this
) => {
  putApiCall(
    `${endPoints.set.setDetails}/${setId}`,
    values,
    (s: any) => {
      const {
        data: { statusCode, message },
      } = s;
      if (statusCode && statusCode === 200) {
        if (cb) cb();
        notify(
          `${type == 'Event' ? 'Activity' : 'Set'} updated successfully`,
          'success',
        );
      }
    },
    (e: any) => {
      if (e?.data?.message) {
        notify(e.data.message, 'error');
      }
      if (onError) onError(); // 👈 call it here
    },
  );
};

export const getSetDetailsbanner = (setId: any, cb?: any) => {
  const { dispatch } = store;
  dispatch(setLoading(true));

  const apiendpoint = endPoints.setDetailbanner + setId;
  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        dispatch(updateSetDetails(data?.data));

        cb(data.data);
      }
      dispatch(setLoading(false));
    },
    (e: any) => {
      dispatch(setLoading(false));
    },
  );
};

// ----------------------- ---------------API CALL PARRALELL -----------

export const getSetDetailsbannerAPI = (setId: any) => {
  const { dispatch } = store;
  dispatch(setLoading(true));

  return new Promise((resolve, reject) => {
    const apiendpoint = endPoints.setDetailbanner + setId;

    getApiCall(
      apiendpoint,
      (s: any) => {
        const { data } = s;
        if (data?.data) {
          dispatch(updateSetDetails(data.data));
          resolve(data.data);
        } else {
          reject('No data');
        }
        dispatch(setLoading(false));
      },
      (e: any) => {
        dispatch(setLoading(false));
        reject(e);
      },
    );
  });
};

export const getCrewDocumentCountAPI = (
  entityType: any,
  entityId: any,
  modelEntityId?: any,
  modelEntityType?: any,
) => {
  const { dispatch } = store;

  let apiendpoint = en`${endPoints.production.crewdoccount}?entityId=${entityId}&entityType=${entityType}`;
  if (modelEntityId && modelEntityType) {
    apiendpoint += `&modelEntityId=${modelEntityId}&modelEntityType=${modelEntityType}`;
  }

  return new Promise((resolve, reject) => {
    getApiCall(
      apiendpoint,
      (s: any) => {
        const { data } = s;
        if (data?.data) {
          dispatch(setCrewDocCount(data.data));
          resolve(data.data);
        } else {
          reject('No data');
        }
      },
      (e: any) => reject(e),
    );
  });
};

export const getSetOrderCountAPI = (entityId: any, type?: string) => {
  const { dispatch } = store;
  let apiendpoint = endPoints.production.setordercount;

  if (type === 'episode') apiendpoint += `?episodeId=${entityId}`;
  else if (type === 'location') apiendpoint += `?locationId=${entityId}`;
  else if (type === 'set') apiendpoint += `?setId=${entityId}`;
  else apiendpoint += `?productionId=${entityId}`;

  return new Promise((resolve, reject) => {
    getApiCall(
      apiendpoint,
      (s: any) => {
        const { data } = s;
        if (data?.data) {
          dispatch(setOrderSetCount(data.data));
          resolve(data.data);
        } else {
          reject('No data');
        }
      },
      (e: any) => reject(e),
    );
  });
};

export const checkPONumber = (
  PONumber: string,
  entityType: string,
  cb?: any,
  entityId?: string,
) => {
  let url = `${endPoints.checkPONumber}?poNumber=${PONumber}&entityType=${entityType}`;

  if (entityId) {
    url += `&entityId=${entityId}`;
  }
  getApiCall(
    url,
    (s: any) => {
      const { data } = s;
      if (data) {
        if (data?.message === 'PO number already exists.') {
          cb(true);
        } else {
          cb(false);
        }
      }
    },
    (e: any) => {
      // Handle error if necessary (you can log it or display a toast, etc.)
      console.error('Error fetching production details:', e);
    },
  );
};

export const CopySet = (values: any, cb?: () => void, onError?: () => void) => {
  postApiCall(
    endPoints.set.copySet,
    values,
    (s: any) => {
      const {
        data: { statusCode, message, data },
      } = s;
      if (statusCode) {
        if (statusCode === 200) {
          notify(message, 'success');
          if (cb) cb(data);
        } else {
          notify(message, 'error');
          if (onError) onError();
        }
      }
    },
    (e: any) => {
      if (e?.data?.message === 'Set already exists.') {
        notify('The set is already associated to this episode', 'error');
      } else {
        notify(e.data.message, 'error');
      }
      if (onError) onError(); // ✅ call this too
    },
  );
};

export const updateSetFormDetails = (data: any, cb?: any) => {
  const { dispatch } = store;

  const contacts = store.getState().set.contacts;

  dispatch(setSetFormDetails(data));
  if (cb) cb(data);
};

export const updateContactsList = (data: any) => {
  const { dispatch } = store;

  const contacts = store.getState().set.contacts;

  console.log(contacts);

  dispatch(setSetContactsList([...contacts, data]));
};

export const removeContactsList = (data: any) => {
  const { dispatch } = store;

  dispatch(setSetContactsList(data));
};
